import { AvailabilityRequestAPI } from '../../apis/availabilityRequest/AvailabilityRequestAPI';

interface AvailabilityRequestPayload {
  userName: string;
  userEmail: string;
  userWhatsApp: string;
  description?: string | null;
  eventDate: string;
  invites: number;
  hasAirConditioner?: boolean | null;
  hasBuffet?: boolean | null;
  hasParking?: boolean | null;
  hasOutdoor?: boolean | null;
  hasSound?: boolean | null;
  hasRoom?: boolean | null;
  places: number[];
  eventTypeId?: number | null;
}

export const AvailabilityRequestService = {
  submit: async (data: AvailabilityRequestPayload) => {
    return await AvailabilityRequestAPI.submit(data);
  },
};
